import React, { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import ComplianceHeader from "components/__new/compliance/ComplianceHeader";
// import { ButtonLoader } from "components/__new/common/form";
import illustration from "assets/images/icons/sad-illustration.png";
import useLoginInfo from "hooks/useLoginInfo";
import * as complianceActions from "store/entities/compliance/action";


const ApprovalRejected = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const {rejectComment} = userInfo.employer;
    
    useEffect(() => {
        if (userInfo.employer.isCompliant === true){
            history.push("/compliance/approval/success");
        }
        dispatch(complianceActions.updateComplianceProgress(100));
        // eslint-disable-next-line
    }, [])
    
    return (
        <div>
            
            <DynamicHeadTag
                headerText="Earnipay Compliance"
                headerDescription="Complete each step to access all Earnipay features"
            />
            
            <ComplianceHeader />
            
            <div className="pt-6 px-6 pb-24 sm:pt-10 sm:px-10">
                <div className="w-full max-w-2xl mx-auto box py-14">
                    <div className="w-full max-w-lg mx-auto flex flex-col items-center">
                        
                        <div className="w-48 h-48 mx-auto flex items-center justify-center">
                            <img src={illustration} alt="Success" className="object-contain" />
                        </div>
                        
                        <div className="mt-8 font-bold text-lg">
                            We are unable to verify your compliance documents due to the following reasons
                        </div>
                        
                        <div className="w-full mt-3 text-sm text-left">
                            <div>
                                Reasons
                            </div>
                            <div className="p-4 mt-1 bg-[#FEF2F2] rounded-md">
                                {rejectComment?.slice(-1)[0]?.comment}
                            </div>
                            <div className="mt-3 text-sm">
                                Kindly check your email for details and instructions on how to proceed
                            </div>
                        </div>
                        
                        <div className="w-full mt-6">
                            <Link to="/compliance" className="btn btn-ep-primary btn-block btn-lg">
                                Edit Details
                            </Link>
                        </div>
                        
                    </div>
                </div>
            </div>
            
        </div>
    )
}


export default ApprovalRejected;